<template>
    <modal
        name="insuranceChargerPopup" :width="880" :height="550" :clickToClose="false"
				@opened="opened">
			<div class="popup on" id="menu_pop05" style="left: 535px; top: 207.5px; display: block;">
				<div class="pop_tit">보험담당자 조회</div>
				<div id="scroll_area" class="scroll_area pop_con_wrap" style="height:400px;">
					<div class="pop_search_bg bgf7">
						<div class="input-group-02">
							<div class="colum-02 col-4">
								<div class="form_box-02">
									<label for="cus">보험사</label>
									<!-- select -->
									<div class="select_wrap">
										<div class="form_select-02">
											<selectInsuranceList v-model="insuranceCompanyValue" />
										</div>
									</div>
									<!-- select -->
								</div>
							</div>
							<div class="colum-02 col-4">
								<div class="form_box-02">
									<label for="code">담당자명</label>
									<input type="text" id="code" class="input-text" placeholder="슼린이" v-model="insuranceChargerName" autocomplete="off">
								</div>
							</div>
							<div class="colum-02 col-1">
								<div class="form_group">
									<a href="javascript:void(0)" class="account_btn" @click="srchBtn()">조회</a>
								</div>
							</div>
						</div>
					</div>
					<div class="pop_search_bg">
						<div class="board_list type02">
							<div class="sub_left_wrap">
								<div class="btn_area mt0">
									<a class="button white" @click="moveToInsuranceManage"><span>보험담당자 관리</span></a>
								</div>
								<div class="destxt vam ml10">보험담당자의  <span>추가/수정/삭제</span>  마다 조정할 수 있습니다. </div>
							</div>
							<grid :options="insuranceChargerList_grid" v-once />
						</div>
					</div>
				</div>
				<div class="pop_footer_wrap">
					<div class="btn_area mt0">
						<a href="javascript:void(0)" class="button blue" @click="chosen"><span>선택</span></a>
						<a href="javascript:void(0)" class="button dark" @click="close"><span>닫기</span></a>
					</div>
				</div>
				
				<a href="javascript:void(0);" class="pop_close" title="close" @click="close">close</a>
			</div>
    </modal>
</template>

<script>
import Vue from 'vue'
import Grid from '@/components/Grid'
import GridModule from '@/modules/grid' 
import SelectInsuranceList from '@/components/SelectInsuranceList'

export default {
	name: 'InsuranceChargerPopup',
	components: { Grid, SelectInsuranceList },
	props: {
    value: ''
	},
	data() {
		return {
			insuranceCompanyList: [],
			insuranceCompanyValue: '',
			insuranceChargerName: '',
			chosenInsuranceChargerRowInfo: '',
			insuranceChargerList_grid: {
				general: {
					id: 'insuranceChargerList-grid',
					search : '/insuranceuser/user/list',
					type: {
						isDataShow: false,
						isUpdate : false,
						isHideAdd : true,
						isHideUpdate : true,
						isHideDel: true,
						isHideReset: true
					},
					PageInfo: {

					},
					params: {
						insuranceChargerName: ''
					},
					excel: false
				},
				grid_options: {
					height: '10row',
          fitTableWidth: true,
					rowSelectOption: {
						clickSelect: true,
						singleSelect: true,
						disableSelectByKey: true
					},
					paging:{
						pagerTotal:false
					},
					columnMapping: [
						{key: 'id', hidden: true},
						{key: 'check', 				title: '선택',			width: '77px',	selectorColumn : true},
						{key: 'loginId', 			title: '담당자ID',	width: '77px',	align: 'center'},
						{key: 'userName',			title: '담당자명',	width: '392px',	align: 'center'},
						{key: 'phoneNumber',	title: '전화번호',	width: '116px',	align: 'center'},
						{key: 'faxNumber',		title: '팩스번호',	width: '116px',	align: 'center', styleclass : "bordr0"}
					]
				}
			}
		}
	},
	computed: {
	},
	mounted() {

	},
	methods: {
    close() {
      this.$modal.hide('insuranceChargerPopup');
		},
		chosen() {
			var data = $('#insuranceChargerList-grid').alopexGrid('dataGet', {_state: {edited:true}}, {_state:{selected:true}});
			if (data == null || data == undefined
				|| data.length == 0) {
					Vue.Alert.alert('선택된 보험 담당자가 없습니다.'); 
					return false;
			}
			this.$emit('insuranceChargerPopup', data[0]);
      this.$modal.hide('insuranceChargerPopup');
		},
    opened(e) {
			this.insuranceCompanyValue = this.value;

			this.srchBtn();

      // close 버튼 표시를 위해 반드시 필요
			$("#menu_pop05").parent().css('overflow', 'visible');
			//팝업창 스크롤바 css 컨트롤(공통)
      $("#scroll_area").mCustomScrollbar( {
        theme: "dark-thick",
        scrollInertia: 500
      });
    },
		srchBtn() {
			// 보험 담당자 조회
			this.insuranceChargerList_grid.general.params.insuranceNo = this.insuranceCompanyValue;
			// 보험사코드
			this.insuranceChargerList_grid.general.params.userName = this.insuranceChargerName;
			// 보험 담당자명
			this.insuranceChargerList_grid.general.PageInfo.current = 1;  

			GridModule.searchData(this.insuranceChargerList_grid);
		},
		moveToInsuranceManage() {
			this.$router.push('/master/InsuranceManage')
		}
	}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/common/InsuranceChargerPopup.vue